// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer___381r3","header":"header___2pZz3","LoginModalContentSize":"LoginModalContentSize___3GAl7","largeContentSize":"largeContentSize___3fpID"};